import * as React from "react";
const SvgMinimize = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 18 2", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M0 0v2h18V0Z", fill: "white" }));
export default SvgMinimize;
